import { LocalizedLink } from "@/components/LocalizedLink";
import { ArrowRight } from "lucide-react";

export interface TopicLink {
  to: string;
  label: string;
}

interface TopicLinksProps {
  title?: string;
  links: TopicLink[];
}

/**
 * Topical internal-link block for blog posts, used to connect editorial
 * content with the product, collection and B2B pages it references.
 */
export const TopicLinks = ({ title = "Related pages", links }: TopicLinksProps) => (
  <nav aria-label={title} className="my-12 rounded-lg border border-border/40 bg-muted/40 p-6">
    <h2 className="font-playfair text-xl font-bold text-primary mb-4">{title}</h2>
    <ul className="grid gap-2 sm:grid-cols-2">
      {links.map((link) => (
        <li key={link.to}>
          <LocalizedLink
            to={link.to}
            className="inline-flex items-center gap-2 text-sm text-foreground hover:text-accent transition-colors"
          >
            <ArrowRight className="w-4 h-4 shrink-0" />
            <span>{link.label}</span>
          </LocalizedLink>
        </li>
      ))}
    </ul>
  </nav>
);

export default TopicLinks;
